import { addOutbound, allOutbounds, deleteOutbound, updateOutbound } from '@/utils/request'
import vue from '@/main'

const state = {
  outboundList: []
}

const mutations = {
  RESET (state) {
    state.outboundList = []
  }
}

const actions = {
  all ({ state }) {
    return new Promise((resolve) => {
      allOutbounds().then(response => {
        state.outboundList = response.data
        resolve(state.outboundList)
      })
    })
  },
  outboundById ({ commit, state }, id) {
    for (const team of state.outboundList) {
      if (team.id === id) return vue.$_.cloneDeep(team)
    }
    return null
  },
  updateOne ({ state }, outbound) {
    return new Promise((resolve) => {
      updateOutbound(outbound).then(() => {
        for (const cur of state.outboundList) {
          if (cur.id === outbound.id) {
            Object.assign(cur, outbound)
            break
          }
        }
        resolve()
      })
    })
  },
  add ({ commit, dispatch, state }, item) {
    return new Promise((resolve) => {
      addOutbound(item).then((response) => {
        state.outboundList.push(response.data)
        resolve(response.data)
      })
    })
  },
  delete ({ commit, dispatch, state }, id) {
    return new Promise((resolve) => {
      deleteOutbound(id).then(() => {
        for (const i in state.outboundList) {
          if (state.outboundList[i].id === id) {
            state.outboundList.splice(i, 1)
          }
        }
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
